/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'printer': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M25 9h1.333c1.746 0 3.166 1.346 3.166 3v10a1 1 0 01-1 1H25v4.5a1 1 0 01-1 1H8a1 1 0 01-1-1V23H3.5a1 1 0 01-1-1V12c0-1.654 1.42-3 3.167-3h1.333V5a1 1 0 011-1h16a1 1 0 011 1v4zm-2-3H9v3h14V6zM9 26.5h14V20H9v6.5zm13.666-10.753a1.5 1.5 0 101.667-2.495 1.5 1.5 0 00-1.667 2.495z" _fill="#0B2C62"/>'
  }
})
